import axios from "axios";
import modal from "../components/modal";

const wishlist = {
  init() {
    this.initRemoveButtons.call(this);
  },

  initRemoveButtons() {
    document.addEventListener('click', (evt) => {
      if(evt.target) {
        if(evt.target.dataset.hasOwnProperty("removeFromWishlist")) {
          this.removeItemFromwishlist(evt.target);
        } else if(evt.target.dataset.hasOwnProperty("addToCartFromWishlist")) {
          evt.preventDefault();
          this.addItemToCart(evt.target);
        } else if(evt.target.dataset.hasOwnProperty("addAllToCart")){
          this.addAlltoCart();
        } else if(evt.target.dataset.hasOwnProperty("clearWishlist")) {
          this.clearWishlist();
        } else if(evt.target.dataset.hasOwnProperty("shareWishlist")) {
          this.onShareWishlistClick(evt.target);
        }
      }
    });
  },

  removeItemFromwishlist(button) {
    const productId = button.dataset.productid;
    const variantId = button.dataset.variantid;

    if(typeof RemoveFromSmartWishlist != null) {
      RemoveFromSmartWishlist(productId, variantId);
      button.closest('.product-card').remove();
    } else {
      console.error("[Wishlist] - RemoveFromSmartWishlist method was not found ");
    }

  },

  addItemToCart(button) {
    const productId = button.dataset.productid;
    const variantId = button.dataset.variantid;

    if(button.dataset.adding) return

    button.dataset.adding = true;
    button.innerHTML = "Adding";

    axios.post("/cart/add.js", {
      id: variantId,
      quantity: 1,
    })
    .then(() => {
      button.innerHTML = "Added"
      button.classList.remove('button-primary');
      button.classList.add('button-success');

      setTimeout(() => {
        const event = new Event('cartUpdated');
        window.dispatchEvent(event);

        if(typeof RemoveFromSmartWishlist != null) {
          RemoveFromSmartWishlist(productId, variantId);
          button.closest('.product-card').remove();
        }else {
          console.error("[Wishlist] - RemoveFromSmartWishlist method was not found ");
        }
      }, 3000);
    })
    .catch(error => {
      button.innerHTML = "Error";
      setTimeout(() => {
        button.innerHTML = "Add to cart"
      }, 3000)
      console.error(error);
    })
  },

  addAlltoCart() {
    const buttons = document.querySelectorAll('[data-add-to-cart-from-wishlist]');
    const wishlistItems = [];
    buttons.forEach((button) => {
      const productId = button.dataset.productid;
      const variantId = button.dataset.variantid;

      wishlistItems.push({
        id: variantId,
        quantity: 1,
        productId,
        button,
      })
    });

    axios.post('/cart/add.js', {
      items: wishlistItems
    }).then( (cart)=> {
      const event = new Event('cartUpdated')
      const gridContainer = document.getElementById('wishlisthtml');
      window.dispatchEvent(event);
      wishlistItems.forEach((item) => {
        if(typeof RemoveFromSmartWishlist != 'undefined' ) {
          RemoveFromSmartWishlist(item.productId, item.id);
        } else {
          console.error("[Wishlist] - RemoveFromSmartWishlist method was not found ");
        }
      })

      gridContainer.innerHTML = `<p style="text-align: center;">There are no items in the Wishlist.</p>`
      gridContainer.classList.remove('grid', 'grid-cols-2', 'lg:grid-cols-3');
      gridContainer.classList.add('text-center');
    })
  },

  clearWishlist() {
    const buttons = document.querySelectorAll('[data-add-to-cart-from-wishlist]');
    const gridContainer = document.getElementById('wishlisthtml');

    buttons.forEach((button) => {
      const productId = button.dataset.productid;
      const variantId = button.dataset.variantid;
      if(typeof RemoveFromSmartWishlist !== 'undefined') {
        RemoveFromSmartWishlist(productId, variantId);
      } else {
        console.error("[Wishlist] - RemoveFromSmartWishlist method was not found ");
      }
    })

    gridContainer.innerHTML = `<p style="text-align: center;">There are no items in the Wishlist.</p>`
    gridContainer.classList.remove('grid', 'grid-cols-2', 'lg:grid-cols-3');
    gridContainer.classList.add('text-center');
  },

  onShareWishlistClick(button) {
    const wishlistId = button.dataset.wishlistId;
    let modalContent = document.querySelector('[data-share-content]').innerHTML;
    const wishlistUrl = `https://${document.location.host}${document.location.pathname}/?wishlist_id=${wishlistId}`;
    const parser = new DOMParser();
    modalContent = modalContent.replaceAll('[[share_link]]', wishlistUrl);
    modalContent = parser.parseFromString(modalContent, 'text/html').querySelector('.modal-content');
    modal.open(modalContent);
  }
}

export default wishlist;
